document.addEventListener("DOMContentLoaded", () => {
    let quickLink = document.querySelector(".js-redirection-return-form");

    if (quickLink) {
        quickLink.addEventListener("click", function (e) {
            e.preventDefault();

            let linkElem = this.querySelector("a")?.href;

            if (!linkElem) return;

            sessionStorage.setItem("returnHref", linkElem);
            window.location.href = linkElem;
        });
    }
});


document.addEventListener("DOMContentLoaded", () => {
    let storedHref = sessionStorage.getItem("returnHref");

    if (!storedHref || storedHref !== window.location.href) return;

    let interval = setInterval(() => {
        let form = document.querySelector("shopify-forms-embed");

        if (form) {
            let headerComponent = document.querySelector(".js-header-component");
            let headerHeight = headerComponent?.offsetHeight || 0;

            let formTop =
                form.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight;

            window.scrollTo({
                top: formTop,
                behavior: "smooth"
            });

            clearInterval(interval);
            sessionStorage.removeItem("returnHref");
        }
    }, 300);
});

